"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Done = _interopRequireDefault(require("@mui/icons-material/Done"));

var _Close = _interopRequireDefault(require("@mui/icons-material/Close"));

var _mdiMaterialUi = require("mdi-material-ui");

var _material = require("@mui/material");

var _style = _interopRequireDefault(require("./style"));

var _SelectMultipleAa = _interopRequireDefault(require("../SelectMultipleAa"));

var _react2 = require("@emotion/react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

class FormAgregados extends _react.default.Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.getObligatoriosConOpciones = this.getObligatoriosConOpciones.bind(this);
    this.state = {
      agregadosComunes: this.props.agregadosComunes ? this.props.agregadosComunes : [],
      agregadosEspeciales: this.props.agregadosEspeciales ? this.props.agregadosEspeciales : []
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.agregadosComunes != this.props.agregadosComunes) {
      this.setState({
        agregadosComunes: this.props.agregadosComunes
      });
    }

    if (prevProps.agregadosEspeciales != this.props.agregadosEspeciales) {
      this.setState({
        agregadosEspeciales: this.props.agregadosEspeciales
      });
    }
  }

  getObligatoriosConOpciones({
    agregado
  }) {
    const {
      obligatorio,
      agregado_tipo,
      observacion,
      descripcion,
      estado,
      id
    } = agregado;
    let data = {
      id: id,
      agregado: agregado.agregado,
      obligatorio: obligatorio,
      agregado_tipo: agregado_tipo,
      estado: estado,
      observacion: observacion,
      multiple: false,
      descripcion: descripcion
    };

    if (agregado.agregado == 'Pileta') {
      data = { ...data,
        multiple: true,
        opciones: [{
          value: 'climatizada',
          label: 'Pileta Climatizada'
        }, {
          value: 'cubierta',
          label: 'Pileta Cubierta'
        }, {
          value: 'exclusiva',
          label: 'Pileta Exclusiva'
        }]
      };
    }

    if (agregado.agregado == 'Cochera') {
      data = { ...data,
        opciones: [{
          value: 1,
          label: '1 auto'
        }, {
          value: 2,
          label: '2 autos'
        }, {
          value: 3,
          label: '3 autos'
        }, {
          value: 4,
          label: '4 autos'
        }, {
          value: 5,
          label: '5 autos'
        }, {
          value: 6,
          label: '6 autos'
        }, {
          value: 7,
          label: '7 autos'
        }, {
          value: 8,
          label: '8 autos'
        }, {
          value: 9,
          label: '9 autos'
        }, {
          value: 10,
          label: '10 o mas autos'
        }]
      };
    }

    return data;
  }

  onChange(name, value, agregado) {
    this.props.onChange(name, value, agregado);
  }

  onDelete(agregado) {//por ahora no se va a usar porq solo mostramos los obligatorios
  }

  render() {
    const {
      agregadosComunes,
      agregadosEspeciales
    } = this.state;
    const {
      puedeAgregar
    } = this.props;
    const agregadosEspecialesFormateados = agregadosEspeciales.map(agregado => {
      return this.getObligatoriosConOpciones({
        agregado
      });
    });

    const agregadosCompletos = _.concat(agregadosComunes, agregadosEspecialesFormateados);

    const agregadosPorGruposObligatorios = _.filter(agregadosCompletos, i => i.obligatorio == 1);

    const agregadosPorGrupos = _.groupBy(agregadosPorGruposObligatorios, 'agregado_tipo');

    return (0, _react2.jsx)("div", null, _.map(agregadosPorGrupos, (data, grupo) => (0, _react2.jsx)(GrupoAgregado, {
      key: grupo,
      grupo: grupo,
      data: data,
      classes: _style.default,
      onChange: this.onChange,
      onDelete: this.onDelete,
      puedeAgregar: puedeAgregar
    })));
  }

}

const GrupoAgregado = ({
  classes,
  grupo,
  data,
  onChange,
  onDelete,
  puedeAgregar
}) => {
  const obligatoriosEspeciales = _.filter(data, i => i.obligatorio == 1 && i.opciones);

  const obligatorios = _.filter(data, i => i.obligatorio == 1 && !i.opciones); // no se muestran agregados no obligatorios por el momento
  // const recomendados = _.filter(data, (i) => i.obligatorio != 1);


  return (0, _react2.jsx)("div", {
    css: classes.containerGrupo
  }, (0, _react2.jsx)(_material.Typography, {
    variant: "body2",
    css: classes.contenido
  }, grupo), (0, _react2.jsx)("div", {
    css: classes.gridContainer
  }, _.map(obligatoriosEspeciales, (item, index) => (0, _react2.jsx)(AgregadoObligatorioEspecial, {
    key: index,
    classes: classes,
    item: item,
    onChange: onChange
  })), _.map(obligatorios, (item, index) => (0, _react2.jsx)(AgregadoObligatorio, {
    key: index,
    classes: classes,
    item: item,
    onChange: onChange
  })), puedeAgregar ? (0, _react2.jsx)("div", {
    css: classes.botonAgregar
  }, (0, _react2.jsx)(_material.Button, {
    color: "primary",
    onClick: () => {}
  }, "+ agregar otro")) : null));
};

const SelectAgregadoEstado = ({
  classes,
  agregado,
  onChange
}) => {
  const itemRender = {
    seleccionar: (0, _react2.jsx)("div", null, "Seleccionar"),
    1: (0, _react2.jsx)(_Done.default, {
      css: classes.icon,
      color: "primary"
    }),
    3: (0, _react2.jsx)(_mdiMaterialUi.Help, {
      css: classes.icon,
      color: "secondary"
    }),
    2: (0, _react2.jsx)(_Close.default, {
      css: classes.icon,
      color: "error"
    })
  };
  return (0, _react2.jsx)(_material.Select, {
    fullWidth: true,
    value: agregado.estado || 0,
    onChange: event => {
      onChange('estado', event.target.value, agregado);
    },
    input: (0, _react2.jsx)(_material.Input, {
      name: "name"
    }),
    renderValue: () => itemRender[agregado.estado]
  }, (0, _react2.jsx)(_material.MenuItem, {
    value: 1
  }, "Si"), (0, _react2.jsx)(_material.MenuItem, {
    value: 3
  }, "Consultar"), (0, _react2.jsx)(_material.MenuItem, {
    value: 2
  }, "No"));
};

const AgregadoObligatorioEspecial = ({
  classes,
  item,
  onChange
}) => {
  return (0, _react2.jsx)(_material.Grid, {
    key: `${item.agregado_tipo}_${item.agregado}`,
    container: true,
    spacing: 1
  }, (0, _react2.jsx)(NombreAgregado, {
    classes: classes,
    agregado: item.agregado,
    obligatorio: item.obligatorio
  }), (0, _react2.jsx)(SelectEstadoAgregado, {
    classes: classes,
    agregado: item,
    onChange: onChange
  }), (0, _react2.jsx)(_material.Grid, {
    item: true,
    lg: 2,
    xs: 3,
    css: classes.gridItem
  }, (0, _react2.jsx)(_SelectMultipleAa.default, {
    onChange: onChange,
    agregado: item
  })), (0, _react2.jsx)(InputObservacion, {
    classes: classes,
    agregado: item,
    onChange: onChange,
    tamanos: {
      lg: 5,
      xs: 4
    }
  }));
};

const AgregadoObligatorio = ({
  classes,
  item,
  onChange
}) => {
  return (0, _react2.jsx)(_material.Grid, {
    key: `${item.agregado_tipo}_${item.agregado}`,
    container: true,
    spacing: 1
  }, (0, _react2.jsx)(NombreAgregado, {
    classes: classes,
    agregado: item.agregado,
    obligatorio: !!item.obligatorio
  }), (0, _react2.jsx)(SelectEstadoAgregado, {
    classes: classes,
    agregado: item,
    onChange: onChange
  }), (0, _react2.jsx)(InputObservacion, {
    classes: classes,
    agregado: item,
    onChange: onChange,
    tamanos: {
      lg: 7,
      xs: 7
    }
  }));
};

const AgregadoNoObligatorio = ({
  classes,
  item,
  onChange,
  onDelete
}) => {
  return (0, _react2.jsx)(_material.Grid, {
    key: `${item.agregado_tipo}_${item.agregado}`,
    container: true,
    spacing: 1
  }, (0, _react2.jsx)(NombreAgregado, {
    classes: classes,
    agregado: item.agregado
  }), (0, _react2.jsx)(SelectEstadoAgregado, {
    classes: classes,
    agregado: item,
    onChange: onChange
  }), (0, _react2.jsx)(InputObservacion, {
    classes: classes,
    agregado: item,
    onChange: onChange,
    tamanos: {
      md: 6,
      xs: 5
    }
  }), (0, _react2.jsx)(_material.Grid, {
    item: true,
    lg: 1,
    xs: 1,
    css: classes.gridItem
  }, (0, _react2.jsx)(_material.IconButton, {
    css: classes.buttonX,
    onClick: () => onDelete(item)
  }, (0, _react2.jsx)(_Close.default, null))));
};

const SelectEstadoAgregado = ({
  classes,
  agregado,
  onChange
}) => {
  return (0, _react2.jsx)(_material.Grid, {
    item: true,
    lg: 1,
    xs: 2,
    css: classes.gridItem
  }, (0, _react2.jsx)(SelectAgregadoEstado, {
    classes: classes,
    onChange: onChange,
    agregado: agregado
  }));
};

const NombreAgregado = ({
  agregado = null
}) => {
  return (0, _react2.jsx)(_material.Grid, {
    container: true,
    item: true,
    lg: 4,
    xs: 3,
    alignItems: "flex-end"
  }, (0, _react2.jsx)(_material.Typography, null, agregado));
};

const InputObservacion = ({
  classes,
  agregado,
  tamanos,
  onChange
}) => {
  return (0, _react2.jsx)(_material.Grid, _extends({
    item: true
  }, tamanos, {
    css: classes.gridItem
  }), (0, _react2.jsx)(_material.TextField, {
    variant: "standard",
    fullWidth: true,
    onBlur: event => {
      onChange('observacion', event.target.value, agregado);
    },
    defaultValue: agregado.observacion || '',
    placeholder: "Observaci\xF3n"
  }));
};

var _default = FormAgregados;
exports.default = _default;